'use strict'

import { apiInstance, b2bReportKey } from './index'
import { mapArgs } from 'utils/functions'

const incentives = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/incentives',
      params
    })
  },

  getDetailById (id, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/incentives/${id}/detail`,
      params
    })
  },

  approved (data) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/incentives/approved`,
      data
    })
  },

  getActives (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/financialAccount/incentives',
      params
    })
  },

  upload (data) {
    return apiInstance({
      method: 'POST',
      url: '/b2b-wallet-app/incentives/upload',
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
      data
    })
  },

  uploadPulling (uploadId) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/incentives/${uploadId}`
    })
  },

  uploadWorker (uploadId) {
    return apiInstance({
      method: 'PATCH',
      url: `/b2b-wallet-app/incentives/${uploadId}/pendingToApproval`
    })
  },

  export () {
    return apiInstance({
      method: 'POST',
      url: `/b2b-report-ws/incentives/incentives`,
      headers: { 'b2b-report-key': b2bReportKey() },
      responseType: 'blob'
    })
  }
}

export default incentives
